import MainLayout from "../../layouts/MainLayout";
import DashboardSummary from "../../components/DashboardSummary/DashboardSummary";
import CallLogsTable from "../../components/CallLogsTable/CallLogsTable";
import "./CallLogs.css";

export default function CallLogs() {
    return (
        <MainLayout>
            <div className="cl-page">
                <DashboardSummary />
                <div className="cl-divider" />
                <CallLogsTable />
            </div>
        </MainLayout>
    );
}